import { useField } from "formik";
import { Form, FormControl, InputGroup } from "react-bootstrap";
import { forwardRef, ReactNode, useRef } from "react";
import { IBaseComponentProps } from "./types";
import clsx from "clsx";
import './style.scss';

interface TextFieldProps extends IBaseComponentProps {
  labelClassName?: string;
  inputClassName?: string;
  prefix?: ReactNode;
  suffix?: ReactNode;
  [key: string]: any;
}

const TextField: React.FC<TextFieldProps> = forwardRef<
  HTMLInputElement,
  TextFieldProps
>(({ 
  labelClassName, 
  inputClassName, 
  containerClassName,
  readOnlyText, 
  variant = 'outlined',
  readOnly,
  prefix,
  suffix,
  ...props 
}, ref) => {
  const [field, meta] = useField(props?.name ?? '');
  const inputRef = useRef<HTMLInputElement>(null);

  const fieldClassName = clsx(
    'spaces px-4 customs-input',
    {
      'is-invalid':(meta.error && meta.touched) || (props?.errors && props?.touched),
    },
    inputClassName,
    props.className,
    `oct-text-field--${variant}`
  );

  return (
		<Form.Group
			className={clsx('text-field-v2 oct-field-wrapper', props?.className, containerClassName)}
		>
			{props?.label && (
				<Form.Label
					className={clsx(
						'text-lable-input max-content-width min-w-fit-content mb-0 spaces',
						{
							'me-2': !labelClassName,
						},
						labelClassName
					)}
				>
					{props?.label}
				</Form.Label>
			)}

			<InputGroup>
				<InputGroup.Text className="p-0 border-0 bg-transparent">
					{prefix}
				</InputGroup.Text>
				<FormControl
					{...field}
					{...props}
					ref={ref || inputRef}
					readOnly={readOnlyText || readOnly}
					className={fieldClassName}
				/>
				<InputGroup.Text className="p-0 border-0 bg-transparent">
					{suffix}
				</InputGroup.Text>
				<Form.Control.Feedback type="invalid" tooltip className="field-tooltip-error">
					{props.errors || meta.error}
				</Form.Control.Feedback>
			</InputGroup>
		</Form.Group>
  );
});

export default TextField;
